var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogoHiphop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#DCE6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55322 51.9533C14.1594 45.3331 21.8236 41 30.4998 41C38.9253 41 46.3965 45.0863 51.0395 51.3853C45.6248 56.713 38.1962 60 29.9998 60C22.0988 60 14.9111 56.9456 9.55322 51.9533Z",
    fill: "#5452FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 24.4939C41 24.0191 38.6998 23.6051 35.3107 23.392C38.3679 21.8335 40.3362 20.5368 40.1615 20.0985C39.9868 19.6601 37.7099 20.1959 34.4955 21.3587C36.7491 18.6983 38.0942 16.7075 37.774 16.3666C37.4537 16.0318 35.5495 17.4381 33.0048 19.7941C34.1112 16.4336 34.6294 14.0593 34.2043 13.8767C33.7851 13.694 32.5389 15.7578 31.0482 18.9539C30.8444 15.4047 30.4484 13 29.9942 13C29.54 13 29.144 15.4047 28.9402 18.9479C27.4494 15.7517 26.2091 13.694 25.7898 13.8767C25.3706 14.0593 25.883 16.4397 26.9894 19.7941C24.4447 17.4381 22.5405 16.0318 22.2202 16.3666C21.8999 16.7014 23.2451 18.6922 25.4987 21.3526C22.2843 20.1959 20.0132 19.6541 19.8385 20.0985C19.6638 20.5368 21.6379 21.8396 24.6893 23.392C21.2943 23.6051 19 24.0191 19 24.4939C19 24.9688 21.3002 25.3827 24.6951 25.5958C21.6379 27.1543 19.6638 28.4571 19.8385 28.8954C20.0132 29.3338 22.2843 28.798 25.4987 27.6413C23.2451 30.3017 21.8999 32.2925 22.2202 32.6273C22.5405 32.9621 24.4447 31.5559 26.9952 29.1998C25.8888 32.5604 25.3706 34.9407 25.7898 35.1233C26.2091 35.306 27.4553 33.2422 28.9402 30.0521C29.144 33.6014 29.54 36 29.9942 36C30.4484 36 30.8444 33.5953 31.0482 30.0521C32.5389 33.2483 33.7792 35.3121 34.2043 35.1294C34.6236 34.9468 34.1112 32.5664 33.0048 29.212C35.5495 31.568 37.4537 32.9743 37.774 32.6395C38.0942 32.3047 36.7491 30.3139 34.4955 27.6535C37.7099 28.8102 39.9809 29.352 40.1556 28.9076C40.3303 28.4693 38.3563 27.1665 35.2991 25.608C38.6998 25.3827 41 24.9688 41 24.4939Z",
    fill: "#5452FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogoHiphop);
export default __webpack_public_path__ + "static/media/user-logo-hiphop.ead25729029a332261506f1cb31dc4ea.svg";
export { ForwardRef as ReactComponent };